module.exports = __webpack_public_path__ + "static/featuredBlockLayout3Front-999bf1bcd487d553f389ce89ec67c32f.png";